<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <b-form-group label="Selecciona el area" label-for="area">
            <v-select v-model="area" :options="options_areas" :clearable="false" id="area"
              :reduce="item => item.label" />
          </b-form-group>
        </b-col>
      </b-row>
      <h4>Reporte 1A - Comparativo de presupuestos (Pivot Table)</h4>
      <div id="reporte1A">
      </div>
      <br>
      <hr class="rounded" />
      <h4>Reporte 1B - Comparativo de presupuestos (Tabla Simple)</h4>
      <div id="reporte1B">
      </div>
      <br>
      <hr class="rounded" />
      <h4>Reporte 2 - Listado de áreas que ya presentaron presupuesto</h4>
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- filter -->
          <b-form-group label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>
      <b-table responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        :small="small" :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion">
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1">
          <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />
        </b-form-group>
        <!-- pagination -->
        <div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
            prev-class="prev-item" next-class="next-item" class="mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      <br>
      <hr class="rounded" />
      <h4>Reporte 3 - Aprobaciones de cada corte</h4>
      <div id="reporte3">
      </div>
    </b-card>
  </div>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import { Pivot } from 'vue-webdatarocks'
import vSelect from 'vue-select'
import 'webdatarocks/webdatarocks.css'

import {
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  VBModal,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BRow,
    BCol,
    Pivot,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [5, 10, 15, 25],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      small: true,
      sortDirection: 'asc',
      items: [],
      fields: [
        {
          key: 'department',
          label: 'Departamento',
          sortable: true,
        },
        {
          key: 'area',
          label: 'Area',
          sortable: true,
        },
        {
          key: 'section',
          label: 'Seccion',
          sortable: true,
        },
        {
          key: 'presented',
          label: 'Presentó',
          sortable: true,
        },
      ],
      filter: null,
      filterOn: [],
      area: null,
      options_areas: [],
      report1a: null,
      report1b: null,
      report3: null,
      report1a_slice: {
        rows: [
          {
            uniqueName: "area"
          },
          {
            uniqueName: "section"
          },
          {
            uniqueName: "position"
          }
        ],
        columns: [
          {
            uniqueName: "year"
          },
          {
            uniqueName: "Measures"
          }
        ],
        measures: [
          {
            uniqueName: "year",
            aggregation: "count"
          }
        ],
        expands: {
          expandAll: true
        }
      },
      report1a_options: {
        grid: {
          type: 'classic',
          showTotals: 'off',
          showGrandTotals: 'columns'
        }
      },
      report1b_slice: {
        rows: [
          {
            uniqueName: "area"
          },
          {
            uniqueName: "section"
          },
          {
            uniqueName: "position"
          }
        ],
        columns: [
          {
            uniqueName: "year"
          },
          {
            uniqueName: "Measures"
          }
        ],
        measures: [
          {
            uniqueName: "year",
            aggregation: "count"
          }
        ],
        expands: {
          expandAll: true
        }
      },
      report1b_options: {
        grid: {
          type: 'flat',
          showTotals: 'on',
          showGrandTotals: 'columns'
        }
      },
      report3_slice: {
        rows: [
          {
            uniqueName: "department"
          },
          {
            uniqueName: "area"
          },
          {
            uniqueName: "section"
          },
          {
            uniqueName: "position"
          }
        ],
        columns: [
          {
            uniqueName: "Measures"
          }
        ],
        measures: [
          {
            uniqueName: "cut1",
            aggregation: "sum"
          },
          {
            uniqueName: "cut2",
            aggregation: "sum"
          },
          {
            uniqueName: "cut3",
            aggregation: "sum"
          }
        ],
        expands: {
          expandAll: true
        },
      },
      report3_options: {
        grid: {
          type: "classic",
          showTotals: "columns"
        }
      },
    }
  },
  mounted() {
    this.initReport1A()
    this.initReport1B()
    this.initReport3()
  },
  created() {
    this.getOptionsAreas()
    this.getDataReport2()
    this.getDataReport3()
  },
  methods: {
    initReport1A() {
      this.report1a = new WebDataRocks({
        container: "#reporte1A",
        toolbar: false,
        report: {}
      });
    },
    initReport1B() {
      this.report1b = new WebDataRocks({
        container: "#reporte1B",
        toolbar: false,
        report: {}
      });
    },
    initReport3() {
      this.report3 = new WebDataRocks({
        container: "#reporte3",
        toolbar: false,
        report: {}
      });
    },
    getDataReport1A() {
      const URL = '/nomina/admin/report_1a'
      const config = {
        method: 'get',
        url: URL,
        params: {
          area: this.area,
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            const report = {
              dataSource: {
                dataSourceType: 'json',
                data: response.data.response,
              },
              slice: this.report1a_slice,
              options: this.report1a_options,
            }
            this.report1a.setReport(report)
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        })
    },
    getDataReport1B() {
      const URL = '/nomina/admin/report_1b'
      const config = {
        method: 'get',
        url: URL,
        params: {
          area: this.area,
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            const report = {
              dataSource: {
                dataSourceType: 'json',
                data: response.data.response,
              },
              slice: this.report1b_slice,
              options: this.report1b_options,
            }
            this.report1b.setReport(report)
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        })
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    getOptionsAreas() {
      const URL = '/nomina/options/areas'
      const config = {
        method: 'get', url: URL
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_areas = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getDataReport2() {
      const URL = '/nomina/admin/report_2'
      const config = {
        method: 'get', url: URL, params: {
          area: this.area,
          app_user_id: this.getUserID(),
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.items = response.data.response.data
            this.totalRows = response.data.response.data.length
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getDataReport3() {
      const URL = '/nomina/admin/report_3'
      const config = {
        method: 'get', url: URL, params: { app_user_id: this.getUserID(), }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            let report = {
              dataSource: {
                dataSourceType: 'json',
                data: response.data.response.data
              },
              slice: this.report3_slice,
              options: this.report3_options,
            }
            this.report3.setReport(report)
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
  },
  watch: {
    area(newArea, oldArea) {
      this.report1a.setReport({})
      this.report1b.setReport({})
      this.getDataReport1A()
      this.getDataReport1B()
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>